import Navbar from "../../components/main/Navbar";
import Loading from "../../components/atoms/Loading";
import Table2 from "../../components/main/Table/Table2";
import {HeaderClientList, HeaderDeviceList} from "../../data/TablesHeader";
import ListsOperations from "../../tools/consts";
import ListPaginationWithLimit from "../../components/pagination/ListPaginationWithLimit";
import DeleteModal from "../../components/atoms/DeleteModal";
import {Toaster} from "react-hot-toast";
import React from "react";
import TableSearchHeader from "../../components/CustomTable/TableSearchHeader";
import {useDevicesContext} from "./DevicesContext";

const DevicesScreen = () => {
    const token = localStorage.getItem("token");
    const {
        modalState,
        listState,
        onBrokerDelete,
        onDeviceDelete,
        changePage,
        onDevicePerPageChange,
        onSearchBtnClick,
        closeModal,
        deleteDeviceCallback,
        deleteBrokerCallback,

    } = useDevicesContext();

    console.log("LIST STATAE : ",listState)
    return (
        <div className="pb-7.5px ">
            <Navbar titles={["دستگاه‌ها", "فهرست دستگاه‌ها"]}/>
            <div
                className="mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px pb-7.5px  "
                dir="rtl">
                <TableSearchHeader
                    title={"فهرست دستگاه‌ها"}
                    number={listState.countAll}
                    placeholder={"جست و جو: شماره سریال، نام مالک، شماره تماس"}
                    onSearchBtnClick={onSearchBtnClick}
                    hasBtn={false}
                    exportFile={false}
                    path={""}
                />
                {listState.loading ? (
                    <Loading height={"h-66"}/>
                ) : (<>
                        <Table2
                            headers={HeaderDeviceList}
                            tableData={listState.list}
                            operations={ListsOperations.getDeviceList(onDeviceDelete, onBrokerDelete, token)}
                            emptyText={"تاریخچه‌ای یافت نشد"}
                            heightEmptyState={'h-66'}
                            pageNumber={listState.pageNumber}
                            limit={listState.pageLimit}
                            hasOperation={true}
                        />
                        <ListPaginationWithLimit
                            changePage={changePage}
                            countAll={listState.countAll}
                            currentPage={listState.pageNumber}
                            devicePerPageLimit={listState.pageLimit}
                            onDevicePerPageChange={onDevicePerPageChange}
                        />

                    </>
                )}
                <DeleteModal
                    text={`آیا برای حذف “${modalState.selectedItem == null ? "" : modalState.selectedItem.serialNumber}” مطمئن هستید؟`}
                    showDeleteModal={modalState.mode === "device" && modalState.isOpen}
                    closeDeleteModal={closeModal}
                    RemoveItem={deleteDeviceCallback}
                    title="اخطار حذف اطلاعات"
                />
                <DeleteModal
                    text={`آیا برای اخراج “${modalState.selectedItem == null ? "" : modalState.selectedItem.serialNumber}” مطمئن هستید؟`}
                    showDeleteModal={modalState.mode === "broker" && modalState.isOpen}
                    closeDeleteModal={closeModal}
                    RemoveItem={deleteBrokerCallback}
                    title="اخطار اخراج از بروکر"
                />

                <Toaster/>
            </div>
        </div>
    )
        ;
}
export default DevicesScreen